"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Extension of the slice function that returns more elements of array if sliceNum is higher than length of array
 * @param array Array that should be cycled & sliced
 * @param sliceNum Number to define the slice; If positive: first n elements are returned; If negative: last n elements are returned
 */
var cycleSlice = function (array, sliceNum) {
    if (!array.length)
        return [];
    var array2use = sliceNum < 0 ? __spreadArrays(array).reverse() : __spreadArrays(array);
    var cycleTimes = Math.ceil(((sliceNum < 0 ? -1 : 1) * sliceNum) / array2use.length);
    var summedArr = [];
    for (var i = 0; i < cycleTimes; i += 1) {
        summedArr.push.apply(summedArr, array2use);
    }
    return sliceNum < 0 ? summedArr.reverse().slice(sliceNum) : summedArr.slice(0, sliceNum);
};
exports.default = cycleSlice;
//# sourceMappingURL=cycleSlice.js.map